import {Service} from "@/apiServices/Service";

export class EmpresaService extends Service {
    constructor() {
        super('empresas/');
    }



    enviarImagen(formData){
        let config = {
            headers: {
                "Content-Type": "image/png",
            },
        };
        return this.http.post(this.getUrl(['imagen']),formData, config)
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })

    }
    detallePlan(idPlan){
        this.onStart();
        return this.http.get(this.getUrl(['detallePlan'], {idPlan}))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })

    }

    getLogoConBase64(idEmpresa){
        return this.http.post(this.getUrl(['obtener','logo','base64']), idEmpresa)
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                // this.onError(e);
                console.error(e)
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
}
